import { render, staticRenderFns } from "./previewComp.vue?vue&type=template&id=84979874&scoped=true&"
import script from "./previewComp.vue?vue&type=script&lang=js&"
export * from "./previewComp.vue?vue&type=script&lang=js&"
import style0 from "./previewComp.vue?vue&type=style&index=0&id=84979874&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84979874",
  null
  
)

export default component.exports